<template>
  <section id="critical-lines">
      <main style="text-align: left; white-space: normal">
          <div class="title" style="color: #CA4123 !important;">
            <icon icoClass='title-ico-orange' selected='criticalLines'/>
            {{ $t('critical_lines') }}
            <a href="/critical-line" style="color: #FFFFFF !important;" class="btn-blue btn-small" v-if="canAdd">{{ $t("add_critical_line") }}</a>
          </div>
          <div id="filters">
            <div v-if="canSeeFilters">
              <div class="field">
                <label>{{ $t("from") }}</label>
                <input type="date" v-model="filters.end_date_after" @change="fillPage(1)"/>
              </div>
              <div class="field">
                <label>{{ $t("to") }}</label>
                <input type="date" v-model="filters.end_date_before" @change="fillPage(1)">
              </div>
            </div>
            <date-filter
            @update="$set(filters, 'end_date_before', $event.before); $set(filters, 'end_date_after', $event.after); fillPage(1)"
            :before="filters.end_date_before"
            :after="filters.end_date_after"
            :today="today"
            initialFilter="from_now"
            :options="['tomorrow', 'next_week', 'next_month', 'from_now']"
            @reset="filters={}; fillPage(1)"
            />
          </div>
          <load-screen :notFullScreen="true" v-show="loadingList"></load-screen>
          <table v-show="!loadingList" class="custom-table" style="width:100%">
            <thead>
              <th v-for="(header,index) in tableHeaders[tableOrder]" :key="index" v-if="header!='actions' || canEdit || canAdd">
                {{ $t(header) }}
              </th>
            </thead>
            <tbody>
              <tr v-for="(criticalLine, index) in objects" :key="index">
                <td v-for="(header,index) in tableHeaders[tableOrder]" :key="index" v-if="header!='actions' || canEdit || canAdd">
                  <div v-if="header=='init_date'">
                    {{ criticalLine.init_date | moment('D/M/YYYY') }}
                  </div>
                  <div v-if="header=='end_date'">
                    {{ criticalLine.end_date | moment('D/M/YYYY') }}
                  </div>
                  <div v-if="header=='cause'">
                    {{ criticalLine.cause }}
                  </div>
                  <div v-if="header=='activity'">
                    {{ criticalLine.activity }}
                  </div>
                  <div v-if="header=='line'">
                    {{ criticalLine.line }}
                  </div>
                  <div v-if="header=='destination'">
                    {{ criticalLine.destination }}
                  </div>
                  <div v-if="header=='product'">
                    {{ criticalLine.product }}
                  </div>
                  <div v-if="header=='contact'">
                    {{ criticalLine.contact }}
                  </div>
                  <div v-if="header=='observations'">
                    {{ criticalLine.observations && criticalLine.observations.length >20 ? criticalLine.observations.slice(0,20) + '...' : criticalLine.observations }}
                  </div>
                  <div v-if="header=='provider'">
                    {{ criticalLine.provider ? criticalLine.provider.description : '' }}
                  </div>
                  <div v-if="header=='client_name'">
                    {{ criticalLine.client ? criticalLine.client.description : '' }}
                  </div>
                  <div v-if="header=='actions'" style="padding:0; font-size:1.5em">
                    <router-link :to="'/critical-line/' + criticalLine.id" :title="$t('detail')" v-if="canEdit">
                      <misc-icon icoClass='title-ico' selected='edit'/>
                    </router-link>
                    <a :title="$t('delete')"  v-if="canDelete" @click="line=criticalLine; showDelete=true">
                      <misc-icon icoClass='title-ico' selected='delete' :title="$t('delete')"/>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div id="pages">
            <div class="move-page" @click="page > 1 ? fillPage(page-1) : ''">
              «{{ $t('prev') }}.
            </div>
            <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown? 'selected-page': 'page'" @click="fillPage(pageShown)">
              {{ pageShown }}
            </div>
            <div class="move-page" @click="page < count/pageSize ? fillPage(page+1) : ''">
              {{ $t('next') }}.»
            </div>
          </div>
          <modal v-show="showDelete">
            <div slot="body" class="delete-modal">
              {{ $t('delete_message') }}
              <div class="buttons">
                <button class="btn-green" @click="deleteLine(line)">{{ $t('ok') }}</button>
                <button class="btn-black" @click="showDelete=false; line=undefined">{{ $t('cancel') }}</button>
              </div>
            </div>
          </modal>
      </main>
    </section>
</template>

<script>
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import icon from './../svg/tabs'
import miscIcon from './../svg/misc'
import DateFilter from './../components/DateFilter'
import StatusCombo from './../components/StatusCombo'
import ReasonCombo from './../components/ReasonCombo'
import {mapActions, mapState} from 'vuex'
import LoadScreen from './../components/LoadScreen'
import Modal from './../components/Modal'
export default {
  name: 'criticalLines',
  components: {icon, miscIcon, DateFilter, StatusCombo, ReasonCombo, LoadScreen, Modal},
  props: {
  },
  mixins: [PaginatedFilteredListMixin],
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.$nextTick(() => {
      this.refresh = setInterval(() => {
        // eslint-disable-next-line
        if (this.$route.name == 'critical-lines') {
          this.fillPage(this.page)
        } else {
          clearInterval(this.refresh)
        }
      }, (60000))// one minute
    })
    this.$nextTick(() => {
      var laps = 0
      this.timer = setInterval(() => {
        laps++
        // eslint-disable-next-line
        if (this.$route.name != 'critical-lines') {
          clearInterval(this.timer)
        } else if (this.auth.userData.roles && this.auth.userData.roles.map((x) => { return x.id }).indexOf(this.auth.kiosk.id) > -1) {
          if (this.page + 1 <= Math.ceil(this.count / this.pageSize)) {
            this.fillPage(++this.page)
          } else {
            this.$emit('next')
            /* this.today = new Date()
            this.fillPage(1) */
          }
          if (laps === 100) {
            laps = 0
            location.reload()
          }
        }
      }, (process.env.REFRESH_TIME * 1000))
    })
    const promises = [
      this.fillPage(this.page),
      this.checkPermissions(['addCL', 'deleteCL', 'editCL', 'seeFilters', 'isForkLift', 'isKiosk']).then((response) => {
        this.canAdd = response.addCL
        this.canDelete = response.deleteCL
        this.canEdit = response.editCL
        this.canSeeFilters = response.seeFilters
        this.tableOrder = !response.isForkLift ? 'forkLift' : !response.isKiosk ? 'kiosk' : 'default'
      })
    ]
    this.$emit('loaded')
    Promise.all(promises).then(data => {
      if (this.user === 'mexico') {
        this.tableOrder = 'mex'
      }
      this.$emit('loaded')
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.refresh)
  },
  data () {
    return {
      objects: [],
      line: undefined,
      showDelete: false,
      loadingTable: false,
      pageSize: 10,
      status: [],
      today: new Date(),
      reasons: [],
      statusMap: new Map(),
      filters: {},
      showStatus: false,
      canAdd: false,
      canEdit: false,
      canSeeFilters: false,
      tableOrder: 'default',
      tableHeaders: {
        default: ['init_date', 'end_date', 'cause', 'activity', 'line', 'destination', 'product', 'contact', 'observations', 'provider', 'client_name', 'actions'],
        mex: ['init_date', 'end_date', 'cause', 'activity', 'line', 'destination', 'product', 'contact', 'observations', 'provider', 'client_name', 'actions'],
        forkLift: ['init_date', 'end_date', 'cause', 'activity', 'line', 'destination', 'product', 'contact', 'observations', 'provider', 'client_name', 'actions'],
        kiosk: ['init_date', 'end_date', 'cause', 'activity', 'line', 'destination', 'product', 'contact', 'observations', 'provider', 'client_name']
      },
      timer: undefined,
      refresh: undefined
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,

      count: state => state.criticalLines.count
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) {
            pages.push(this.page - index)
          }
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) {
            pages.push(this.page + index)
          }
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  methods: {
    ...mapActions({
      saveCriticalLines: 'criticalLines/save',
      checkPermissions: 'auth/checkPermissions',
      deleteLines: 'criticalLines/delete',
      getObjects: 'criticalLines/list'
    }),
    deleteLine (line) {
      this.deleteLines(line.id).then(() => {
        this.fillPage(this.page)
        this.showDelete = false
      })
    },
    fillPage (page) {
      var filters = Object.assign({}, {page: page, page_size: this.pageSize}, this.filters)
      this.filters = filters
      this.getPage(page)
    }
  }
}
</script>

<style scoped lang="scss">
#criticalLines {
  display: table;
}
#status-box {
  position: absolute;
  top: 4em;
  left: 0;
  background: white;
  width: 100%;
  border: 1px solid #E1E1E1;
  box-sizing: border-box;
  z-index: 999;
  padding: .3em;
}
a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageCriticLines.vue